import { defineComponent as _defineComponent } from 'vue'
import { cachedAsyncSvgLoader } from '@shared/lib';
    import { IconBase } from '@shared/ui';
    import Airplane from '../assets/airplane.svg';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'BonusMilesIcon',
  setup(__props) {

    const AirplaneIcon = cachedAsyncSvgLoader(Airplane);


return { __sfc: true,AirplaneIcon, IconBase }
}

})